import React, { useContext } from 'react';
import './HeroSection.css';
import 'aos/dist/aos.css';
import 'react-phone-number-input/style.css'
import { UserContext } from '../../context/FormDataContext.js';

function HeroSection(props) {
    const { updateUserFormData } = useContext(UserContext);
    const onInitialSubmit = (e) => {
        e.preventDefault();
        const firstName = e.target['waitlist[first_name]'].value;
        const lastName = e.target['waitlist[last_name]'].value;
        //e.target.reset();
        //updateUserFormData({ firstName, lastName, showJoinWaitList: true });
        updateUserFormData({ firstName, lastName });
        //handleShow();
       props.setShowJoinWaitList(true);
    };
    console.log("Show modal triggered")

    return (
        <>
            <section id="hero" className="hero section">
                <video width="100%" autoPlay muted playsInline loop>
                    <source src="https://images.rentid.io/img/bg-video.mp4" type="video/mp4" />
                </video>

                <div className="container banner-content px-0">
                    <div className="row align-items-center">
                        <div className="col-xl-7 col-lg-7 px-0">
                            <h1>All-in-one car rental platform & back office</h1>
                            {/* <p>The only end-to-end solution with embedded insurance, trust and safety workflows, resolution center for operators. </p>  */}
                            {/* <p>The only end-to-end solution with trust and safety tools, embedded insurance, roadside assistance, and resolution center car rental hosts.</p> */}
                            <p>The only end-to-end solution with embedded trust & safety tools, insurance, roadside assistance and resolution center.</p>
                            <div className="row">
                                <div className="col-md-8 ps-0 waitlist_sec">
                                    <div className="banner-form">
                                        <h3>Join The Waitlist</h3>
                                        <form onSubmit={onInitialSubmit}>
                                            <div className="row align-items-center">
                                                <div className="col-md-5 ps-0 waitlist_form">
                                                    <div className="">
                                                        <label htmlFor="first_name" className="form-label">
                                                            First Name
                                                        </label>
                                                        <input type="text" className="form-control" id="first_name"
                                                            name="waitlist[first_name]" aria-describedby="emailHelp" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-5 waitlist_form">
                                                    <div className="">
                                                        <label htmlFor="last_name" className="form-label">
                                                            Last Name
                                                        </label>
                                                        <input type="text" className="form-control" id="last_name"
                                                            name="waitlist[last_name]" aria-describedby="emailHelp" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-2 ps-0">
                                                    <div className="">
                                                        <button type="submit" className="banner-btn">
                                                            <img src="/img/arrow.svg" className='me-2' alt="Arrow" />{" "}
                                                            Enter
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                        <p className="privacy_policy">
                                            Your information is safe with us. Read our <a href="privacy" target='_blank'>Privacy Policy.</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HeroSection;
